import { reactive } from 'vue'

const state = reactive({
  timezone: '',
  loaded: false
})

export async function loadTimezone() {
  if (state.loaded) return
  try {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || ''
    const res = await fetch(`${baseUrl}/api/system/config`)
    const json = await res.json()
    if (json?.data?.system?.timezone) {
      state.timezone = json.data.system.timezone
    }
  } catch (e) {
    console.warn('[timezone] Failed to load site timezone:', e.message)
  }
  state.loaded = true
}

export function getSiteTimezone() {
  return state.timezone || undefined
}

export function formatDateTime(dateStr, locale, options = {}) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  const tz = getSiteTimezone()
  const defaults = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
  const opts = { ...defaults, ...options }
  if (tz) opts.timeZone = tz
  return date.toLocaleString(lang, opts)
}

export function formatDate(dateStr, locale) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  const tz = getSiteTimezone()
  const opts = { year: 'numeric', month: '2-digit', day: '2-digit' }
  if (tz) opts.timeZone = tz
  return date.toLocaleDateString(lang, opts)
}

export function formatTime(dateStr, locale) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  const tz = getSiteTimezone()
  const opts = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }
  if (tz) opts.timeZone = tz
  return date.toLocaleTimeString(lang, opts)
}

export function formatTimezoneLabel() {
  const tz = getSiteTimezone()
  if (!tz) {
    const off = -new Date().getTimezoneOffset() / 60
    return `UTC${off >= 0 ? '+' : ''}${off}`
  }
  try {
    const part = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'shortOffset' })
      .formatToParts(new Date()).find(p => p.type === 'timeZoneName')
    return part ? part.value : tz
  } catch (_e) { return tz }
}
